module.exports = __webpack_public_path__ + "img/guideThree.8fbfcf59.png";